import type { CommonReponse } from "../types/CommonReponse";

const httproot='https://geo.autonomia.org';
interface MunicipalitiesPostalinfos{
    postalinfo:number,
    municipality:string
}

export function getPostCodeMunicipalities(postcode:string,callback:(a:string[])=>void){
    if(!postcode){
        callback([]);
        return;
    }
    fetch(httproot+'/municipalities_postalinfos?r[postalinfo]='+postcode).then(reponse=>{
        return reponse.json()
    }).then( (data:CommonReponse<MunicipalitiesPostalinfos>)=>{
        callback(data.data.map((e:MunicipalitiesPostalinfos)=>e.municipality));
    }).catch(()=>{
        console.log('municipalities error');
    })
}